import { render, staticRenderFns } from "./ProtectionsList.vue?vue&type=template&id=1aacfb31&scoped=true"
import script from "./ProtectionsList.vue?vue&type=script&lang=js"
export * from "./ProtectionsList.vue?vue&type=script&lang=js"
import style0 from "./ProtectionsList.vue?vue&type=style&index=0&id=1aacfb31&prod&lang=scss&scoped=true"
import style1 from "./ProtectionsList.vue?vue&type=style&index=1&id=1aacfb31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aacfb31",
  null
  
)

export default component.exports